import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 3rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    margin: 2rem;
  }
`;

export const RowTableDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const Key = styled.h6`
  color: ${({ theme }) => theme.colors?.text.primary};
`;

export const Value = styled.h6`
  color: ${({ theme }) => theme.colors?.text.secondary};
`;
